import {Box, ListingGroupList, ListingsAndGroups, Text} from "@hosttools/frontend";
import type {Listing} from "@hosttools/frontend/models/listing";
import type {ListingGroup} from "@hosttools/frontend/models/listingGroup";
import type React from "react";
import {memo, useCallback} from "react";
import {useHistory} from "react-router-dom";

import {getListingGroupUrl, getMessagingListingUrl} from "./util";

type Props = {
    listingGroups: ListingGroup[];
    onClick?: () => void;
};

const MessagingMenu: React.FC<Props> = ({listingGroups, onClick}) => {
    const history = useHistory();

    const handlePressListing = useCallback(
        (listing: Listing) => {
            onClick?.();
            history.push(getMessagingListingUrl(listing._id));
        },
        [onClick, history]
    );

    const handlePressListingGroup = useCallback(
        (listingGroupID: string) => {
            onClick?.();
            history.push(getListingGroupUrl(listingGroupID));
        },
        [onClick, history]
    );

    return (
        <Box className="flex flex-col lg:flex-row gap-4 lg:gap-6 w-full px-5 lg:px-0">
            <Box className="w-full lg:w-[192px] lg:py-3 lg:max-h-[384px] overflow-y-auto">
                <ListingGroupList
                    className="px-2 py-4 lg:py-0"
                    listingGroups={listingGroups}
                    onPressListingGroup={handlePressListingGroup}
                />
            </Box>
            <Box className="max-w-full lg:min-w-[360px] lg:max-w-[480px] lg:max-h-[384px] border border-solid border-blueGray-200 rounded-lg bg-blueGray-50 overflow-y-auto">
                <Text className="px-5 pt-4" color="blueGray.800" variant="md">
                    Listings
                </Text>
                <ListingsAndGroups className="lg:gap-0" onPressListing={handlePressListing} />
            </Box>
        </Box>
    );
};

export default memo(MessagingMenu);
